import { render, staticRenderFns } from "./NotificationPopup.vue?vue&type=template&id=e3e47bba"
import script from "./NotificationPopup.vue?vue&type=script&lang=ts"
export * from "./NotificationPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports